import React from 'react';

// component
import Header from '../../components/header';
import JobOpeningList from './job-opening-list';

// helper
import { useLanguage } from '../../helpers/language-context';
import { renderHTML } from '../../helpers/render-html';

// data
// import jobOpeningList from '../../data/job-opening-list.json';

const flexibilityIcon = (
    <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#FDA729" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
        <path d="M18 2h4v4" />
        <path d="M10 14L22 2" />
    </svg>
);

const growthIcon = (
    <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#FDA729" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 7l-8.5 8.5-5-5L2 17" />
        <path d="M16 7h6v6" />
    </svg>
);

const collaborativeIcon = (
    <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#FDA729" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
);


const CareerPage = () => {
    const { translations } = useLanguage();

    const scrollToJobList = () => {
        const element = document.getElementById('job-list');
        if (element) {
            const navbarHeight = 100; // Offset for navbar
            const elementPosition = element.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({
                top: elementPosition - navbarHeight,
                behavior: 'smooth'
            });
        }
    };

    return (
        <div>
            <Header
                title={translations.career.title}
                flip={true}
                bgImg="/assets/images/section-img/tree_planting_event.jpg"
                description={true}
                descriptionText={translations.career.description}
                button={true}
                buttonText={translations.career.seeAvailablePositions}
                buttonLink="/career"
                onButtonClick={scrollToJobList}
            />
            <section className="bg-white">
                <div className="flex flex-col space-y-4 text-center justify-center items-center mx-auto">
                    <div className="md:max-w-[60%]">
                        <h2 className="text-4xl md:text-5xl lg:text-6xl text-[#28357B] mb-4 md:mb-8">{translations.career.aboutWorkingHere}</h2>
                    </div>
                    <div className="space-y-2 md:max-w-[80%]">
                        <p className="text-sm text-black" dangerouslySetInnerHTML={renderHTML(translations.career.subTitle)} />
                    </div>
                </div>
            </section>
            <section className="bg-white pt-0">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-4">
                    <div className="space-y-4">
                        {flexibilityIcon}
                        <h3 className="text-lg font-medium text-[#28357B]">{translations.career.flexibility}</h3>
                        <p className="text-sm text-black" dangerouslySetInnerHTML={renderHTML(translations.career.flexibilityDesc)} />
                    </div>
                    <div className="space-y-4">
                        {growthIcon}
                        <h3 className="text-lg font-medium text-[#28357B]">{translations.career.growthAndLearning}</h3>
                        <p className="text-sm text-black" dangerouslySetInnerHTML={renderHTML(translations.career.growthAndLearningDesc)} />
                    </div>
                    <div className="space-y-4">
                        {collaborativeIcon}
                        <h3 className="text-lg font-medium text-[#28357B]">{translations.career.collaborativeCulture}</h3>
                        <p className="text-sm text-black" dangerouslySetInnerHTML={renderHTML(translations.career.collaborativeCultureDesc)} />
                    </div>
                </div>
            </section>
            <div className="w-full h-[35vh] md:h-[45vh] flex">
                <img
                    src="/assets/images/section-img/career_about_1.jpg"
                    alt="section-career1"
                    className="w-1/3 h-full object-cover"
                />
                <img
                    src="/assets/images/section-img/career_about_2.png"
                    alt="section-career2"
                    className="w-1/3 h-full object-cover"
                />
                <img
                    src="/assets/images/section-img/career_about_3.jpg"
                    alt="section-career3"
                    className="w-1/3 h-full object-cover"
                />
            </div>
            <div id="job-list">
                <JobOpeningList />
            </div>
            <div className="bg-white w-full">
                <div className="h-screen">
                    <img src="/assets/images/section-img/section_career_new.jpg" alt="Board" className="object-cover h-screen w-full" />
                </div>
            </div>
            <section className="bg-[#28357B]">
                <div className="text-start text-white space-y-12">
                    {/* Orange Icon/Logo */}
                    <div className="mb-8">
                        <div className="text-orange-500 flex items-center justify-start">
                            <svg
                                height="27px"
                                width="27px"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                                fill="currentColor"
                                style={{ transform: 'rotate(180deg)' }}
                            >
                                <g>
                                    <path
                                        d="M119.472,66.59C53.489,66.59,0,120.094,0,186.1c0,65.983,53.489,119.487,119.472,119.487 c0,0-0.578,44.392-36.642,108.284c-4.006,12.802,3.135,26.435,15.945,30.418c9.089,2.859,18.653,0.08,24.829-6.389 c82.925-90.7,115.385-197.448,115.385-251.8C238.989,120.094,185.501,66.59,119.472,66.59z"
                                        fill="currentColor"
                                    />
                                    <path
                                        d="M392.482,66.59c-65.983,0-119.472,53.505-119.472,119.51c0,65.983,53.489,119.487,119.472,119.487 c0,0-0.578,44.392-36.642,108.284c-4.006,12.802,3.136,26.435,15.945,30.418c9.089,2.859,18.653,0.08,24.828-6.389 C479.539,347.2,512,240.452,512,186.1C512,120.094,458.511,66.59,392.482,66.59z"
                                        fill="currentColor"
                                    />
                                </g>
                            </svg>
                        </div>
                    </div>

                    {/* Main Text */}
                    <h1 className="text-lg lg:text-2xl text-white mb-8 leading-tight">
                        Our commitment goes beyond construction. We build foundations for communities, create pathways for progress, and engineer solutions that stand the test of time.
                    </h1>

                    {/* Author Info */}
                    <div className="border-l-4 border-orange-500 pl-4">
                        <p className="text-white font-semibold text-lg">Nizran Noordin</p>
                        <p className="text-gray-300 text-sm">Chief Executive Officer</p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default CareerPage;
